import { useTranslation } from 'react-i18next'
import { SEO } from '@/components/SEO'
import { HeroSection } from './HeroSection'
import { NewsGrid } from './NewsGrid'

export function NewsPage() {
  const { t } = useTranslation('common')

  return (
    <>
      <SEO
        title={t('nav.news')}
        description={t('news.metaDescription')}
        type="website"
      />
      <main id="main-content">
        <HeroSection />
        <NewsGrid />
      </main>
    </>
  )
}
